import React, { memo, useState, useCallback } from 'react';
import { size } from 'lodash';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import type { PriceInfoProps } from './PriceInfo';
import PriceInfo from './PriceInfo';

const baseCls = 'checkout-summary-prices-mobile';

const PriceInfoMobile = ({ data }: PriceInfoProps) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);
  const onToggle = useCallback(
    () => setShowDetails((prevValue) => !prevValue),
    [],
  );

  const showBlock = size(data) > 1;
  if (!showBlock) {
    return null;
  }

  return (
    <div className={baseCls}>
      <Button className="lt-link" functional onClick={onToggle}>
        {t('checkout.services.buttonMobile')}
      </Button>
      {showDetails && (
        <div className={`${baseCls}__details`}>
          <div className={`${baseCls}__details--tooltip`} />
          <button
            type="button"
            className={`${baseCls}__details--close`}
            onClick={onToggle}
          />
          <div className={`${baseCls}__details--content`}>
            <div className="like-h3">{t('checkout.services.all')}</div>
            <PriceInfo data={data} />
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(PriceInfoMobile);
